/*
 * -----------------------------------------------------------------------
 *  <copyright file="edit-risk-overview-config.helper.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { StudyFields } from '@queries/generated/fragments.generated';

export const formRiskOverviewData = (study: StudyFields) => {
    const config = study.riskOverviewConfiguration;

    return {
        amberDecisionKris: config?.amberDecisionKris || false,
        amberKris: config?.amberKris || false,
        numSubjects: config?.numSubjects || false,
        redDecisionKris: config?.redDecisionKris || false,
        redKris: config?.redKris || false,
        siteActiveDate: config?.siteActiveDate || false,
        siteCountry: config?.siteCountry || false,
        siteMonitor: config?.siteMonitor || false,
        siteStatus: config?.siteStatus || false,
        subjectField: config?.subjectField ?? '',
        displayRiskOverviewOnStudySummary: study.displayRiskOverviewOnStudySummary,
    };
};
